import { render, staticRenderFns } from "./global-forms-manager.vue?vue&type=template&id=b1ba0b0a&scoped=true&"
import script from "./global-forms-manager.vue?vue&type=script&lang=js&"
export * from "./global-forms-manager.vue?vue&type=script&lang=js&"
import style0 from "./global-forms-manager.vue?vue&type=style&index=0&id=b1ba0b0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1ba0b0a",
  null
  
)

export default component.exports